import React from 'react';
import '../styles/uploadProgress.css';

/**
 * Progress for one multipart request, which may contain several files.
 * `count={0}` is a save with nothing to upload: an indeterminate "Saving…" bar.
 * `savingLabel` is what shows once every byte is sent and the server is still working.
 */
const UploadProgress = ({ progress, count = 1, queued = false, cancelling = false, savingLabel = 'Saving to storage…', onCancel }) => {
    const known = count > 0 && Number.isFinite(progress);
    const saving = known && progress >= 100;
    const label = cancelling
        ? 'Cancelling upload…'
        : queued
        ? 'Waiting to upload'
        : count === 0
            ? savingLabel
            : saving
            ? savingLabel
            : `Sending ${count} file${count === 1 ? '' : 's'} to portal${known ? ` · ${progress}%` : '…'}`;

    return (
        <div className="file-upload-status" role="status" aria-live="polite">
            <div className="file-upload-status-top">
                <span>{label}</span>
                {!saving && !cancelling && onCancel && (
                    <button type="button" onClick={onCancel} aria-label="Cancel upload">Cancel</button>
                )}
            </div>
            {!queued && (
                <div
                    className="file-upload-track"
                    role="progressbar"
                    aria-label={count === 0 ? 'Saving' : 'File upload'}
                    aria-valuemin={0}
                    aria-valuemax={100}
                    aria-valuenow={known && !saving ? progress : undefined}
                >
                    <div className={`file-upload-fill ${known && !saving ? '' : 'is-indeterminate'}`} style={known && !saving ? { width: `${progress}%` } : undefined} />
                </div>
            )}
        </div>
    );
};

export default UploadProgress;
